import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/data-table/data-table";
import { exportDataToCsv } from "@/utils/exportToCsv";
import { Organization } from "../types";
import { columns } from "./columns";

interface OrganizationsTableProps {
  organizations: Organization[];
}

export function OrganizationsTable({ organizations }: OrganizationsTableProps) {
  return (
    <div className="-mx-4 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-x-12 lg:space-y-0">
      <DataTable
        tableId="root-user-organizations"
        data={organizations}
        columns={columns}
        searchColumn="name"
        searchPlaceholder="Search organizations..."
        facetedFilters={[
          {
            columnId: "status",
            title: "Status",
            options: [
              { label: "New", value: "NEW" },
              { label: "Onboarding", value: "ONBOARDING" },
              { label: "Gestating", value: "GESTATING" },
              { label: "Live", value: "LIVE" },
              { label: "Dead", value: "DEAD" },
              { label: "Test", value: "TEST" },
            ],
          },
        ]}
        defaultSort={[{ id: "createdAt", desc: true }]}
        floatingActionItems={(table) => {
          const selectedCount = table.getSelectedRowModel().rows.length;
          const selectedRows = table
            .getSelectedRowModel()
            .rows.map((row) => row.original);
          return [
            <div
              key="selectedCount"
              className="text-muted-foreground mr-2 flex items-center text-sm"
            >
              {selectedCount} selected
            </div>,
            <Button
              key="export-csv"
              variant="default"
              size="sm"
              className="space-x-1"
              onClick={() => exportDataToCsv(selectedRows, "organizations.csv")}
            >
              <span>Export CSV</span>
            </Button>,
          ];
        }}
      />
    </div>
  );
}
